declare global {
  // guard name -> whether its client form has hydrated
  var __hydrated: Record<string, boolean> | undefined;
}

export function markHydrated(name: string): void {
  if (typeof window === "undefined") return;
  globalThis.__hydrated = globalThis.__hydrated ?? {};
  globalThis.__hydrated[name] = true;
}

/**
 * Returns the inline `<script>` source for `<HydrationGuard>`: reveals the banner
 * and fires a `hydration_stalled` PostHog event when `useHydrated(name)` has not
 * marked the guard hydrated within `timeoutMs`. Uses `window.posthog` when it has
 * loaded, otherwise sends the event directly to `/ingest/e/` with `posthogToken`.
 */
export function hydrationStallScript(
  name: string,
  bannerId: string,
  timeoutMs: number,
  posthogToken: string,
): string {
  const key = JSON.stringify(name);
  const id = JSON.stringify(bannerId);
  const token = JSON.stringify(posthogToken ?? "");
  return (
    `(function(){window.__hydrated=window.__hydrated||{};` +
    `if(window.__hydrated[${key}]===undefined)window.__hydrated[${key}]=false;` +
    `setTimeout(function(){if(window.__hydrated[${key}])return;` +
    `var b=document.getElementById(${id});` +
    `if(b){b.hidden=false;var a=b.querySelector('a[data-hydration-refresh]');` +
    `if(a)a.setAttribute('href',window.location.href);}` +
    `try{if(window.posthog){window.posthog.capture('hydration_stalled',{guard:${key}});}` +
    `else if(${token}){` +
    `var did;try{var c=document.cookie.split('; ').find(function(x){return x.indexOf('ph_'+${token}+'_posthog=')===0;});` +
    `if(c)did=(JSON.parse(decodeURIComponent(c.slice(c.indexOf('=')+1)))||{}).distinct_id;}catch(e){}` +
    `var body=JSON.stringify({api_key:${token},event:'hydration_stalled',distinct_id:did||('hydration_stalled_'+Date.now()),properties:{guard:${key},$current_url:window.location.href}});` +
    `if(navigator.sendBeacon){navigator.sendBeacon('/ingest/e/',new Blob([body],{type:'application/json'}));}` +
    `else{fetch('/ingest/e/',{method:'POST',headers:{'Content-Type':'application/json'},body:body,keepalive:true});}` +
    `}}catch(e){}` +
    `},${timeoutMs});})();`
  );
}
